<script>
    import {dateTodayUS, localizeDate} from "../../../../utils/date";
    import Datepicker from '../../common/datepicker.vue'
    import Timepicker from "../../common/timepicker.vue";

    export default {
        name: "screenshot-actionbar",
        props: {
            date: String,
            time: String
        },
        components: {
            Datepicker,
            Timepicker
        },
        computed: {
            translations() {
                return {
                    search: Lang.langGet("Search"),
                    reset: Lang.langGet("Reset Date & Time"),
                    loadError: Lang.langGet("Cannot load screenshots.")
                }
            },
            dateTodayLocalized() {
                return localizeDate(dateTodayUS());
            },
            maxDate() {
                return dateTodayUS();
            }
        },
    }
</script>

<template>
    <div class="d-flex align-center justify-center ma-2 pa-2">
        <div class="show-no-details mr-2">
            <datepicker
                :value="date"
                @input="$emit('dateChange', $event)"
                :placeholder="dateTodayLocalized"
                :max="maxDate"
                popup-used-in-modal
            />
        </div>
        <div class="mr-2">
            <timepicker
                id="screenshot-timepicker"
                :value="time"
                @input="$emit('timeChange', $event)"
                picker-family="screenshot-time"
                popup-used-in-modal
                hide-format-hint
            />
        </div>
        <v-btn
            type="button"
            class="btn btn-primary submit mr-2"
            @click.stop.prevent="$emit('search', $event)">
                {{ translations.search }}
        </v-btn>
        <v-btn
            type="button"
            class="btn btn-secondary"
            @click.stop.prevent="$emit('reset', $event)">
                {{ translations.reset }}
        </v-btn>
    </div>
</template>

<style>
    .show-no-details .v-input .v-text-field__details {
        display: none !important;
    }
</style>
